import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import http from '@/assets/plugin/axios'

declare global {
    interface Window {
        Pusher: typeof Pusher
    }
}

const key = import.meta.env.VITE_PUSHER_APP_KEY as string

let echo: Echo<'pusher'> | null = null

if (key) {
    window.Pusher = Pusher

    echo = new Echo({
        broadcaster: 'pusher',
        key,
        cluster: (import.meta.env.VITE_PUSHER_APP_CLUSTER as string) || 'ap1',
        forceTLS: true,
        authorizer: (channel: { name: string }) => ({
            authorize: (socketId: string, callback: (error: Error | null, data: unknown) => void) => {
                http.post('/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                    .then((response) => callback(null, response.data))
                    .catch((error) => callback(error as Error, null))
            },
        }),
    })
}

export default echo
